/* unplugin-vue-components disabled */import script from "./MenuCart.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuCart.vue?vue&type=script&setup=true&lang=js"

import "./MenuCart.vue?vue&type=style&index=0&id=6a49aa23&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a49aa23"]])

export default __exports__